import { useReducer } from "react";
import { Table } from "semantic-ui-react";
import cellFooterValue from "./cellFooterValue";
import cellValue from "./cellValue";
import tableReducer from "./tableReducer";

import "./style.css";

const TableComponent = ({
  tableData,
  tableHeaders,
  tableFooters,
  striped,
  sortable,
  celled,
  handleIconclick,
}) => {
  const [state, dispatch] = useReducer(tableReducer, {
    column: null,
    data: tableData,
    direction: null,
  });
  const { column, data, direction } = state;

  return (
    <Table striped={striped} sortable={sortable} celled={celled}>
      <Table.Header>
        <Table.Row>
          {tableHeaders.map(({ header, title, textAlign }) => (
            <Table.HeaderCell
              textAlign={textAlign ? textAlign : "left"}
              key={header}
              sorted={column === header && sortable ? direction : null}
              onClick={() =>
                sortable
                  ? dispatch({ type: "CHANGE_SORT", column: header })
                  : null
              }
            >
              {title}
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {data.map((ent) => (
          <Table.Row key={ent.id}>
            {tableHeaders.map((entHeader) => (
              <Table.Cell
                key={entHeader.header}
                textAlign={entHeader.textAlign ? entHeader.textAlign : "left"}
              >
                {cellValue(entHeader, ent, handleIconclick)}
              </Table.Cell>
            ))}
          </Table.Row>
        ))}
      </Table.Body>
      {tableFooters && (
        <Table.Footer>
          <Table.Row>
            {tableHeaders.map((entHeader) => (
              <Table.HeaderCell
                key={entHeader.header}
                textAlign={entHeader.textAlign ? entHeader.textAlign : "left"}
              >
                {cellFooterValue(entHeader, data)}
              </Table.HeaderCell>
            ))}
          </Table.Row>
        </Table.Footer>
      )}
    </Table>
  );
};

export default TableComponent;
